import React, { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

const ConfirmValuesCheckBox = forwardRef(({ checked, handleClick }, ref) => {
  const { t } = useTranslation()

  return (
    <div ref={ref} className="board-background mt-3">
      <label htmlFor='confirmCheckbox' className="checkbox-container d-flex align-items-center">
        <input onChange={handleClick} name='confirmCheckbox' type="checkbox" checked={checked} />
        <span onClick={handleClick} className="checkmark"></span>
        <small onClick={handleClick} className="text text-left color-grey pl-3"><b>{t('submitedInformationIsTrue')}</b></small>
      </label>
    </div>
  )
})

export default ConfirmValuesCheckBox
